/* MXDVS product page reviews in pages, assets/mxdvs-reviews-pages.js (22.10.2026). Loaded by sections/mxdvs-product-reviews.liquid.
   Demo "Reviews Pages Mobile", Max's saved settings: 3 reviews per page, navigation look C "Bars" (one thin bar per page,
   "01 / 14" on the right). Changing page slides like the You may also like tabs: the old page leaves 70px the other way in
   220ms, the new one comes in from 70px in 380ms. Phones: a sideways swipe on the reviews changes page.
   Also: the rating under the product title reads 4.9/5 (no spaces around the slash).
   22.10.2026 15:40 (Max's screenshots):
   - Judge.me lays out and pages its own widget (its own column positions and its own pages of reviews). That widget now stays
     loaded but out of sight, untouched, and assets/mxdvs-product-lower.js keeps building our cards inside it.
   - Every finished card is copied once into our own page box (.mxrv-pg) with a fixed grid: 3 equal columns on desktop, one
     under the other on phones, so the cards always show at their final size.
   - Judge.me shows its reviews in pages of its own: our script asks Judge.me for the page that holds the reviews it needs,
     remembers every card it has seen, and builds our pages of 3 from those, so the bars and "01 / 14" always follow.
   - While a page changes, the list holds its height, then eases to the new page's height; the window stays where it was.
   22.10.2026 15:45: Judge.me could still scroll the page down while loading; now any script scrolling is switched off
   for that moment (keepScroll), and it also covers every page change, not only loading.
   22.10.2026 15:50 (Max's video): a first-time page load takes Judge.me a few seconds; the scroll block now lasts until the
   new reviews are in (plus a moment), not a fixed 1.5 seconds. Our card copies no longer carry Judge.me's own review class
   (Judge.me removed every element with that class while loading, which emptied our page box): they are .mxrv-rev now.
   22.10.2026 21:15: Translate on a copied card translates in place again with the browser's own translator (Chrome).
   22.10.2026 21:30 (Max): visitors are never sent away from the site: no Google Translate. Browsers without a built-in
   translator (Safari, Firefox, iPhone) do not show the Translate button at all; if the translator cannot help, the button
   says "Translation not available". */
(function () {
  if (window.MxRvPages) return;
  window.MxRvPages = true;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* Rating under the product title: "4.9 / 5" becomes "4.9/5", again after every redraw of the product view */
  function initRating() {
    var view = document.querySelector('[data-mxp] [data-mxp-view]');
    if (!view) return;
    function fix() {
      var r = view.querySelector('.pp-rating'); if (!r) return;
      var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) { var t = n.nodeValue.replace(/\s*\/\s*5\b/g, '/5'); if (t !== n.nodeValue) n.nodeValue = t; }
    }
    new MutationObserver(fix).observe(view, { childList: true, subtree: true });
    fix();
  }

  /* Keep the window where it is while Judge.me changes page (22.10.2026 15:45: it scrolled the page down before our
     correction could catch it). For that short time every way a script can scroll the page does nothing: window scrolling,
     scrollIntoView, setting scrollTop on the page, and focus() never scrolls. Everything is put back after the time asked
     (asked again while running, it only ever gets longer, never shorter). The visitor's own scrolling (wheel, touch, keys) is never blocked. */
  var ks = null;
  function keepShort(ms) { if (ks) ks.end = Math.min(ks.end, Date.now() + ms); }
  function keepScroll(ms) {
    if (ks) { ks.end = Math.max(ks.end, Date.now() + ms); return; }
    var W = window, E = Element.prototype, H = HTMLElement.prototype, de = document.documentElement, bd = document.body;
    var o = { to: W.scrollTo, by: W.scrollBy, s: W.scroll, siv: E.scrollIntoView, focus: H.focus };
    var st = Object.getOwnPropertyDescriptor(E, 'scrollTop');
    var noop = function () {};
    ks = { end: Date.now() + ms, y: scrollY };
    W.scrollTo = W.scrollBy = W.scroll = noop;
    E.scrollIntoView = noop;
    H.focus = function (opt) { var a = {}; if (opt) for (var k in opt) a[k] = opt[k]; a.preventScroll = true; return o.focus.call(this, a); };
    if (st && st.get) [de, bd].forEach(function (el) { if (el) Object.defineProperty(el, 'scrollTop', { configurable: true, get: function () { return st.get.call(this); }, set: noop }); });
    var user = false, mine = function () { user = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { addEventListener(ev, mine, { passive: true }); });
    (function f() {
      if (Date.now() > ks.end) {
        W.scrollTo = o.to; W.scrollBy = o.by; W.scroll = o.s; E.scrollIntoView = o.siv; H.focus = o.focus;
        [de, bd].forEach(function (el) { if (el) delete el.scrollTop; });
        ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { removeEventListener(ev, mine, { passive: true }); });
        ks = null;
        return;
      }
      if (user) ks.y = scrollY;
      else if (Math.abs(scrollY - ks.y) > 1) o.to.call(W, 0, ks.y);
      requestAnimationFrame(f);
    })();
  }

  function initPages(sec) {
    if (sec.dataset.mxpg) return;
    var host = sec.querySelector('.mxrv__list'), widget = sec.querySelector('#judgeme_product_reviews');
    if (!host || !widget) return;
    sec.dataset.mxpg = '1';
    sec.classList.add('mxpg-on');
    var per = Math.max(1, parseInt(sec.dataset.pageSize, 10) || 3);
    var page = 0, want = -1, busy = false, lastNav = '', started = false, relT = 0;
    var cache = [], jpSize = 0, jpCur = 1, loading = false, loadT = 0;
    var box = document.createElement('div'); box.className = 'mxrv-pg';
    var nav = document.createElement('div'); nav.className = 'mxrv-nav'; nav.hidden = true;
    host.appendChild(box); host.appendChild(nav);

    var revs = function () { return Array.prototype.slice.call(sec.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev')); };
    var total = function () { var w = sec.querySelector('.jdgm-rev-widg'), t = w && parseInt(w.dataset.numberOfReviews, 10); return t || revs().length; };
    var pages = function () { return Math.max(1, Math.ceil(total() / per)); };
    var appendMode = function () { return !!sec.querySelector('.jdgm-paginate__load-more'); };
    var curJp = function () { var c = sec.querySelector('.jdgm-paginate__page.jdgm-curt'), n = c && parseInt(c.getAttribute('data-page'), 10); return n || jpCur; };

    /* copy every finished card once, stored at its place in the full list of reviews */
    function collect() {
      var rs = revs(), grew = false;
      if (!rs.length) return false;
      if (!jpSize) jpSize = rs.length;
      var base = appendMode() ? 0 : (curJp() - 1) * jpSize;
      rs.forEach(function (r, i) {
        var g = base + i, card = r.querySelector('.mxrv-card');
        if (cache[g] || !card) return;
        var w = document.createElement('div');
        w.className = 'mxrv-rev';
        w.appendChild(card.cloneNode(true));
        /* no built-in translator in this browser: no Translate button */
        if (!('Translator' in self)) w.querySelectorAll('.mxrv-tr').forEach(function (b) { b.remove(); });
        cache[g] = w; grew = true;
      });
      return grew;
    }
    var range = function (p) { var s = p * per; return [s, Math.min(total(), s + per)]; };
    function have(p) { var r = range(p); for (var g = r[0]; g < r[1]; g++) if (!cache[g]) return false; return true; }
    function firstMissing(p) { var r = range(p); for (var g = r[0]; g < r[1]; g++) if (!cache[g]) return g; return -1; }
    /* ask Judge.me for the reviews this page still needs */
    function fetchFor(p) {
      if (loading) return true;
      var el = null, g = firstMissing(p);
      if (g < 0) return false;
      if (appendMode()) el = sec.querySelector('.jdgm-paginate__load-more');
      else if (jpSize) {
        var jp = Math.floor(g / jpSize) + 1, cur = curJp();
        el = sec.querySelector('.jdgm-paginate__page[data-page="' + jp + '"]');
        if (el) jpCur = jp;
        else if (jp > cur && (el = sec.querySelector('.jdgm-paginate__next-page'))) jpCur = cur + 1;
        else if (jp < cur && (el = sec.querySelector('.jdgm-paginate__prev-page'))) jpCur = cur - 1;
      }
      if (!el) return false;
      loading = true;
      keepScroll(8000);
      el.click();
      clearTimeout(loadT);
      loadT = setTimeout(function () { loading = false; keepShort(0); }, 7000);
      return true;
    }
    function render() {
      var y = scrollY, r = range(page);
      while (box.firstChild) box.removeChild(box.firstChild);
      for (var g = r[0]; g < r[1]; g++) if (cache[g]) box.appendChild(cache[g]);
      if (Math.abs(scrollY - y) > 1) scrollTo(0, y);
    }
    function hold() {
      clearTimeout(relT);
      box.style.transition = '';
      box.style.height = box.offsetHeight + 'px';
      box.style.overflowY = 'clip';
    }
    function release() {
      if (!box.style.height) return;
      var h0 = box.offsetHeight;
      box.style.height = 'auto';
      var h1 = box.offsetHeight;
      box.style.height = h0 + 'px';
      void box.offsetHeight;
      if (RM || Math.abs(h1 - h0) < 1) { box.style.height = ''; box.style.overflowY = ''; return; }
      box.style.transition = 'height 380ms cubic-bezier(.2,.8,.2,1)';
      box.style.height = h1 + 'px';
      relT = setTimeout(function () { box.style.transition = ''; box.style.height = ''; box.style.overflowY = ''; }, 420);
    }
    function drawNav() {
      var n = pages(), h = '';
      if (page > n - 1) page = n - 1;
      if (n > 1) {
        h = '<div class="mxrv-nav__bars" role="group" aria-label="Review pages">';
        for (var q = 0; q < n; q++) h += '<button type="button" data-page="' + q + '" aria-label="Reviews page ' + (q + 1) + '"' + (q === page ? ' class="is-on" aria-current="true"' : '') + '></button>';
        h += '</div><span class="mxrv-nav__n"><b>' + pad(page + 1) + '</b> / ' + pad(n) + '</span>';
      }
      nav.hidden = n < 2;
      if (h !== lastNav) { lastNav = h; nav.innerHTML = h; }
      nav.classList.toggle('is-loading', want > -1);
    }
    function go(to) {
      to = Math.max(0, Math.min(pages() - 1, to));
      if (to === page || busy) return;
      if (!have(to)) {
        want = to; hold(); drawNav();
        if (!fetchFor(to)) { want = -1; drawNav(); release(); return; }
        /* Judge.me did not answer: let go after 6 seconds */
        setTimeout(function () { if (want === to) { want = -1; drawNav(); release(); } }, 6000);
        return;
      }
      var dir = to > page ? 1 : -1;
      if (RM || !box.animate) { hold(); page = to; render(); drawNav(); release(); return; }
      busy = true;
      keepScroll(700);
      hold();
      var out = box.animate([{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(' + (-dir * 70) + 'px)', opacity: 0 }], { duration: 220, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' });
      var done = false, fin = function () {
        if (done) return; done = true;
        page = to; render(); drawNav(); out.cancel();
        release();
        box.animate([{ transform: 'translateX(' + (dir * 70) + 'px)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }], { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' });
        busy = false;
      };
      /* the swap never waits on the animation alone */
      out.onfinish = fin; setTimeout(fin, 260);
    }

    nav.addEventListener('click', function (e) { var b = e.target.closest('[data-page]'); if (b) go(+b.dataset.page); });
    /* Translate on a copied card (22.10.2026 21:15): the browser's own translator (Chrome, on the device, free), the text
       decoding into English in place; "Translated / show original" switches back. Nothing ever opens another site. */
    var GL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    function decodeTo(el, text, dur) {
      if (!el) return;
      if (RM) { el.textContent = text; return; }
      dur = dur || 600; var t0 = performance.now(), id = (el._mxd || 0) + 1; el._mxd = id;
      (function f(now) {
        if (el._mxd !== id) return;
        var k = Math.min(1, (now - t0) / dur), s = '';
        for (var i = 0; i < text.length; i++) s += (k >= (i + 1) / text.length || /[\s.,:;!?'"()-]/.test(text[i])) ? text[i] : GL[(Math.random() * GL.length) | 0];
        el.textContent = s;
        if (k < 1) requestAnimationFrame(f);
      })(t0);
    }
    box.addEventListener('click', function (e) {
      var tr = e.target.closest && e.target.closest('.mxrv-tr'); if (!tr) return;
      e.preventDefault(); e.stopPropagation();
      var c = tr.closest('.mxrv-rev'), title = c && c.querySelector('[data-rt]'), body = c && c.querySelector('[data-rb]');
      if (!body) return;
      if (c._orig) {
        var o = c._orig; c._orig = null;
        if (title) decodeTo(title, o.t); decodeTo(body, o.b, 800); tr.textContent = 'Translate to English'; return;
      }
      var orig = { t: title ? title.textContent : '', b: body.textContent }, src = tr.dataset.src || '';
      if (!('Translator' in self) || tr.disabled) return;
      var fail = function () { tr.textContent = 'Translation not available'; tr.disabled = true; };
      tr.textContent = '> translating';
      /* the translator can take a while the first time (it downloads a language model); after 15 seconds it gives up */
      var gave = false, fallT = setTimeout(function () { gave = true; fail(); }, 15000);
      var lang = src ? Promise.resolve(src) : ('LanguageDetector' in self ? self.LanguageDetector.create().then(function (d) { return d.detect(orig.b); }).then(function (r) { return r && r[0] ? r[0].detectedLanguage : ''; }) : Promise.resolve(''));
      lang.then(function (l) {
        if (!l || l === 'und' || l === 'en') throw new Error('no language');
        return self.Translator.create({ sourceLanguage: l, targetLanguage: 'en' });
      }).then(function (t) {
        return Promise.all([orig.t ? t.translate(orig.t) : '', t.translate(orig.b)]);
      }).then(function (out) {
        clearTimeout(fallT); if (gave) return;
        c._orig = orig;
        if (title && out[0]) decodeTo(title, out[0]); decodeTo(body, out[1], 900);
        tr.textContent = 'Translated / show original';
      }).catch(function () { clearTimeout(fallT); if (gave) return; fail(); });
    }, true);
    var sx = 0, sy = 0;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.5) go(page + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* follow Judge.me's widget (only the widget is watched, never our own box or bars, so this cannot loop) */
    var tick = 0;
    function update() {
      if (collect()) { loading = false; clearTimeout(loadT); keepShort(800); }
      if (!started && have(0)) { started = true; render(); }
      if (want > -1) {
        if (have(want)) { var w = want; want = -1; go(w); }
        else if (!loading) fetchFor(want);
      }
      drawNav();
    }
    new MutationObserver(function () {
      if (tick) return;
      tick = requestAnimationFrame(function () { tick = 0; update(); });
    }).observe(widget, { childList: true, subtree: true });
    update();
  }

  function boot() {
    initRating();
    document.querySelectorAll('[data-mxrv]').forEach(initPages);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
